export type SectionMarginOptions = {
	useSectionMargins?: boolean;
	useExtraTopMargins?: boolean;
	useExtraBottomMargins?: boolean;
};

/** Balanced default — same top and bottom. */
export const SECTION_MARGIN_DEFAULT = "py-8 md:py-20";

/** Extra top + section margins — scaled-up top. */
export const SECTION_MARGIN_EXTRA_TOP_SCALED =
	"pt-12 pb-6 md:pt-24 md:pb-12";

/** Extra top only — emphasized side uses default section padding. */
export const SECTION_MARGIN_EXTRA_TOP_BASE = "pt-8 pb-6 md:pt-20 md:pb-12";

/** Extra bottom + section margins — scaled-up bottom. */
export const SECTION_MARGIN_EXTRA_BOTTOM_SCALED =
	"pt-6 pb-12 md:pt-12 md:pb-32";

/** Extra bottom only — emphasized side uses default section padding. */
export const SECTION_MARGIN_EXTRA_BOTTOM_BASE = "pt-6 pb-8 md:pt-12 md:pb-20";

export const SECTION_MARGIN_NONE = "py-0";

/**
 * Resolves vertical section padding.
 * Extra top/bottom alone uses default section size on the emphasized side;
 * with useSectionMargins also on, that side scales up further.
 */
export function getSectionMarginClasses(
	options: SectionMarginOptions = {}
): string {
	const {
		useSectionMargins = false,
		useExtraTopMargins = false,
		useExtraBottomMargins = false,
	} = options;

	if (useExtraTopMargins) {
		return useSectionMargins
			? SECTION_MARGIN_EXTRA_TOP_SCALED
			: SECTION_MARGIN_EXTRA_TOP_BASE;
	}

	if (useExtraBottomMargins) {
		return useSectionMargins
			? SECTION_MARGIN_EXTRA_BOTTOM_SCALED
			: SECTION_MARGIN_EXTRA_BOTTOM_BASE;
	}

	if (useSectionMargins) return SECTION_MARGIN_DEFAULT;
	return SECTION_MARGIN_NONE;
}
